import React from "react";
import cn from "classnames";

/**
 * Thin vertical drag handle for resizable side panels. Spread the
 * `handleProps` from `useResizablePanel` onto it. Absolutely positioned on
 * the given edge of a `relative` parent; a wider invisible hit area sits
 * around the 1px visible line so it's easy to grab.
 */
interface Props extends React.HTMLAttributes<HTMLDivElement> {
  edge: "left" | "right";
  active?: boolean;
  /** Hide below md (mobile layouts are full-width overlays). Default true. */
  desktopOnly?: boolean;
}

const ResizeHandle: React.FC<Props> = ({ edge, active, desktopOnly = true, className, ...rest }) => (
  <div
    role="separator"
    aria-orientation="vertical"
    title="Drag to resize · double-click to reset"
    className={cn(
      desktopOnly ? "hidden md:block" : "block",
      "absolute top-0 bottom-0 w-2 z-30 cursor-col-resize group/resize touch-none select-none",
      edge === "left" ? "-left-1" : "-right-1",
      className,
    )}
    {...rest}
  >
    <div
      className={cn(
        "absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-[2px] transition-colors duration-150",
        active ? "bg-blue-500" : "bg-transparent group-hover/resize:bg-blue-400/70",
      )}
    />
  </div>
);

export default ResizeHandle;
